import { Trash, File } from "lucide-react";
import { useDispatch } from 'react-redux';
import { chageStatePlaceThunk } from '../../store/slices/public/procesoMatriculacion.slice';
import { useParams } from "react-router-dom";

const CardPlace = ({ title, item }) => {

    const dispatch = useDispatch();

    const handleChangeState = () => {
        dispatch(chageStatePlaceThunk(item))
    }

    return (
        <div className="bg-white rounded-2xl shadow-lg p-4 border border-gray-200">
            <div className='flex items-center gap-2 mb-3'>
                <File className="w-4 h-4" />
                <h2 className="text-lg font-semibold text-gray-700 uppercase text-left">{title}</h2>
            </div>
            <div className="space-y-3">
                {!item ? (
                    <p className="text-sm text-gray-400">No hay elementos</p>
                ) : (
                    <div className="flex gap-3 justify-between items-center bg-gray-100 rounded-xl px-3 py-2 hover:bg-gray-200 transition">
                        <div className='flex flex-col justify-start text-left'>
                            <span className="text-sm font-medium text-gray-600 ">
                                Cupo reservado: {item.cupo?.reserva_cupo}
                            </span>
                            <span className="text-sm font-medium text-gray-600 ">
                                Transporte: {item.cupo?.servicio_transporte}
                            </span>
                            <span className="text-sm font-medium text-gray-600 ">
                                Curso/Grado: {item.cupo?.grado}
                            </span>
                            <span
                                className={`text-[12px] font-semibold flex items-center gap-1 mt-1 ${item.idReservacionCupo > 0 ? "text-green-600" : "text-red-500"
                                    }`}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-4 w-4"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    {item.idReservacionCupo > 0 ? (
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    ) : (
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    )}
                                </svg>
                                {item.idReservacionCupo > 0 ? "Cupo procesado" : "Falta procesar cupo para el estudiante"}
                            </span>
                        </div>
                        <div className="flex gap-2">
                            <button
                                disabled={!item.idReservacionCupo ? true : false }
                                onClick={handleChangeState}
                                className={`flex items-center gap-2 text-white px-4 py-2 rounded-xl shadow-md  ${!item.idReservacionCupo ? ' bg-slate-300' : 'bg-gradient-to-r from-rose-400 to-red-500 hover:from-rose-500 hover:to-red-600'} transition-all duration-300 ease-in-out`}
                            >
                                <Trash className="w-4 h-4" />
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CardPlace;